import React, { useState, useEffect, useContext, createContext } from 'react';

const gradientColorContext = createContext();
export const Usegradientcolorcontext = () => useContext(gradientColorContext);

const useGradientColor = () => {
    const [copy, setCopy] = useState(null);

    const handleColors = (colorHexCode) => {
        const copyCode = colorHexCode;
        const text = document.createElement("textarea");
        document.body.appendChild(text);
        text.value = copyCode;
        text.select();
        document.execCommand("copy");
        document.body.removeChild(text);
        setCopy(colorHexCode);
        localStorage.setItem("Copy", copy);
        const getCopiedItem = localStorage.getItem("Copy");
        if (getCopiedItem === "null" || getCopiedItem !== "null") {
            setTimeout(function () {
                setCopy(null);
            }, 3000);
        }
    };

    const handleGradientColors = (colorHexCode) => {
        handleColors(colorHexCode);
    };

    return {
        copy,
        handleGradientColors,
    }
}

export function ProvideGradientColor({ children }) {
    const gradientColor = useGradientColor();
    return <gradientColorContext.Provider value={gradientColor}>{children}</gradientColorContext.Provider>
}
